import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { _eventBus } from "../../../../core/events/EventBus";
export class SetCursorAction extends BaseAction<void, string[]> {
    override async run(): Promise<void | null> {
        try {
            updateRecoilState('passengerSeatCursorAtom', this.params)
        } catch (error) {
            console.error("Error in SetCursorAction:", error);
        }
    }
}

export const setCursorAction = new SetCursorAction(); 